import {useEffect} from "react";
import {useLocation} from "react-router-dom";

const SHEETS = [
  "/css/fonts.css",
  "/css/style.css",
  "/css/shop-grid.css",
  "/css/shop-modal.css",
  "/css/shop-header.css",
  "/css/shop-filters.css",
  "/css/shop-trust-bar.css",
  "/css/shop-brands.css",
  "/css/shop-skeleton.css",
  "/css/shop-new-hub.css",
  "/css/shop-cart.css",
  "/css/shop-wishlist.css",
  "/css/shop-cart-drawer.css",
  "/css/shop-home-banners.css",
  "/css/shop-home-perfume-spotlight.css",
  "/css/shop-home-brands-marquee.css",
  "/css/shop-home-departments.css",
  "/css/shop-home-promo-tabs.css",
  "/css/shop-department-hub.css",
  "/css/shop-carousel.css",
  "/css/shop-checkout.css",
  "/css/shop-form-validation.css",
  "/css/shop-contact.css",
  "/css/shop-faq.css",
  "/css/shop-cms.css",
  "/css/shop-info-page.css",
  "/css/shop-category-hero.css",
  "/css/shop-footer.css",
  "/css/shop-account.css",
  "/css/shop-pdp-summary.css",
  "/css/shop-pdp-layout.css",
  "/css/shop-pdp-buy.css",
  "/css/shop-pdp-tabs.css",
  "/css/shop-pdp-delivery.css",
  "/css/shop-pdp-fancybox.css",
  "/css/shop-product-carousel.css"
];

function ensureSheet(href: string) {
  const sel = `link[rel="stylesheet"][href="${href}"]`;
  if(document.querySelector(sel)) return;
  const link = document.createElement("link");
  link.rel = "stylesheet";
  link.href = href;
  document.head.appendChild(link);
}

/** Re-attach legacy stylesheets after soft navigation (static export). Skipped on /vadmin. */
export function LegacyStyles() {
  const pathname = useLocation().pathname;
  useEffect(() => {
    if(pathname.startsWith("/vadmin")) return;
    for(const href of SHEETS) ensureSheet(href);
  }, [pathname]);
  return null;
}
